// Featured creators — real photos + MySpace-style profile data.
const MAKENZIE_PHOTO =
  "https://customer-assets-v7afamib.emergentagent.net/job_luxury-talent-3d/artifacts/oh64angj_Screen%20Shot%202026-08-12%20at%207.24.37%20PM.png";

export const CREATORS = [
  {
    slug: "makenzie",
    name: "Makenzie",
    theme: "glam",
    accent: "#ff2e9a",
    handle: "@k.enziie",
    mood: "✿ online now ✿",
    tagline: "college life, glam & everything pink ✨",
    about: "NSU baddie 💅 sharing my glam routines, campus life & all things pink. get in, we're glowing up. 🎀",
    photo: MAKENZIE_PHOTO,
    avatar: MAKENZIE_PHOTO,
    cover: MAKENZIE_PHOTO,
    followers: "820",
    brand: {
      name: "Princess Polly",
      url: "https://get.aspr.app/SH202h",
      code: "POLLYCOLLEGEMAKENZIEF",
      discount: "15% off",
    },
    socials: [
      { type: "instagram", url: "https://instagram.com/m.aakenzie", handle: "m.aakenzie" },
      { type: "tiktok", url: "https://tiktok.com/@k.enziie", handle: "@k.enziie" },
    ],
    // legacy fields for secondary routes
    stats: { followers: "820", engagement: "9.6%", vibe: "Pink" },
    bio: "NSU baddie sharing glam routines, campus life and all things pink.",
    location: "NSU • Campus Life",
    stories: [{ image: MAKENZIE_PHOTO, caption: "get ready with me 💕" }],
  },
];

export const getCreator = (slug) => CREATORS.find((c) => c.slug === slug);
